export class CategoryModel {
  [key: string]: any;
  id: string
  title: string
  image_url: string
  description: string
  constructor(obj: any = null) {
    this.id = obj?.id
    this.title = obj?.title
    this.image_url = obj?.image_url
    this.description = obj?.description
  }
}
